import { Button, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function DemoStep2() {
  return (
    <>
      <div className="form">
        <div className="gap_p">
          <div className="control_group w_50">
            <h3 className='hd_6'>  Upload Trade License<Tooltip title="Upload Trade License"><InfoOutlinedIcon /></Tooltip></h3>
            <div className="upload_box">
              <label className='upload_action'>
                <input type="file" />
                <p>
                  <img src="/static/images/upload_icon.svg" alt='icon' />
                  <strong>Click to upload or drag and drop</strong>
                </p>
              </label>
            </div>
          </div>
          <div className="control_group w_50">
            <h3 className='hd_6'>Upload Memorandum of Association (MOA)(Optional) <Tooltip title="Upload MOA"><InfoOutlinedIcon /></Tooltip></h3>
        
            <div className="upload_box">
              <label className='upload_action'>
                <input type="file" />
                <p>
                  <img src="/static/images/upload_icon.svg" alt='icon' />
                  <strong>Click to upload or drag and drop</strong>
                </p>
              </label>
            </div>
                <p>Note:Your may upload this later.</p>
          </div>
        </div>

     
      </div>
    </>
  )
}

export default DemoStep2